import { motion, AnimatePresence } from "framer-motion";

export const ShowreelModal = ({ open, onClose }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[95] bg-black/95 flex items-center justify-center p-4 sm:p-10"
        onClick={onClose}
        data-testid="showreel-modal"
      >
        <button
          onClick={onClose}
          data-testid="showreel-close-button"
          className="absolute top-6 right-6 z-10 w-12 h-12 rounded-full bg-[#E80042] text-white font-bold text-xl hover:rotate-90 transition-transform duration-300"
        >
          ✕
        </button>
        <motion.div
          initial={{ scale: 0.92, y: 30 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.92, y: 30 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="w-full max-w-6xl aspect-video rounded-lg overflow-hidden bg-black"
          onClick={(e) => e.stopPropagation()}
        >
          <iframe
            src="https://www.youtube.com/embed/GaeoGkGGC9o?autoplay=1&rel=0"
            title="WVE Studios Showreel"
            className="w-full h-full border-0"
            allow="autoplay; fullscreen; encrypted-media"
            data-testid="showreel-video-player"
          />
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
